export const FETCH_ENABLED_PROVIDERS = 'pos_config/FETCH_ENABLED_PROVIDERS';
export const FETCH_ENABLED_PROVIDERS_SUCCESS =
  'pos_config/FETCH_ENABLED_PROVIDERS_SUCCESS';
export const FETCH_ENABLED_PROVIDERS_FAILURE =
  'pos_config/FETCH_ENABLED_PROVIDERS_FAILURE';

export const FETCH_POS_CONFIG = 'pos_config/FETCH_POS_CONFIG';
export const FETCH_POS_CONFIG_SUCCESS = 'pos_config/FETCH_POS_CONFIG_SUCCESS';
export const FETCH_POS_CONFIG_FAILURE = 'pos_config/FETCH_POS_CONFIG_FAILURE';

export const FETCH_POS_CONFIG_LIST = 'pos_config/FETCH_POS_CONFIG_LIST';
export const FETCH_POS_CONFIG_LIST_SUCCESS =
  'pos_config/FETCH_POS_CONFIG_LIST_SUCCESS';
export const FETCH_POS_CONFIG_LIST_FAILURE =
  'pos_config/FETCH_POS_CONFIG_LIST_FAILURE';

export const CREATE_POS_CONFIG = 'pos_config/CREATE_POS_CONFIG';
export const CREATE_POS_CONFIG_SUCCESS = 'pos_config/CREATE_POS_CONFIG_SUCCESS';
export const CREATE_POS_CONFIG_FAILURE = 'pos_config/CREATE_POS_CONFIG_FAILURE';

export const UPDATE_POS_CONFIG = 'pos_config/UPDATE_POS_CONFIG';
export const UPDATE_POS_CONFIG_SUCCESS = 'pos_config/UPDATE_POS_CONFIG_SUCCESS';
export const UPDATE_POS_CONFIG_FAILURE = 'pos_config/UPDATE_POS_CONFIG_FAILURE';

export const DELETE_POS_CONFIG = 'pos_config/DELETE_POS_CONFIG';
export const DELETE_POS_CONFIG_SUCCESS = 'pos_config/DELETE_POS_CONFIG_SUCCESS';
export const DELETE_POS_CONFIG_FAILURE = 'pos_config/DELETE_POS_CONFIG_FAILURE';

export const FETCH_GUEST_LIST = 'pos_config/FETCH_GUEST_LIST';
export const FETCH_GUEST_LIST_SUCCESS = 'pos_config/FETCH_GUEST_LIST_SUCCESS';
export const FETCH_GUEST_LIST_FAILURE = 'pos_config/FETCH_GUEST_LIST_FAILURE';

export const action = (type: string): IAction => ({
  type,
});

export const actionSuccess = <T>(type: string, payload: T): IAction => ({
  type: `${type}_SUCCESS`,
  payload,
});

export const actionFailure = <T>(type: string, payload: T): IAction => ({
  type: `${type}_FAILURE`,
  payload,
});
